import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { Box, Stack, Typography, TextField, Button, Modal, Card, CardContent, CardHeader, Checkbox, Alert, LinearProgress, Divider, IconButton } from '@mui/material';
import { SnackbarAlert } from '../../../../components-core/SnackbarAlert';

import { sendNotificationAction } from '../../../../services/request';

import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const validationSchema = Yup.object({
  message: Yup.string().required('To pole nie może być puste'),
  subject: Yup.string().required('To pole nie może być puste')
});

export default function SendMessageModal({ order, open, handleClose }) {
  const { mutate, error, loading, reset } = useMutation(sendNotificationAction);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleCloseModal = () => {
    reset();
    handleClose();
    formik.resetForm();
  };

  const handleSubmit = async values => {
    const { error: mutateError } = await mutate(values);
    if (!mutateError) {
      handleCloseModal();
      setOpenSnackbar(true);
    }
  };

  const formik = useFormik({
    initialValues: {
      message: '',
      subject: ''
    },
    validationSchema,
    validateOnChange: false,
    onSubmit: values => {
      values.order_id = order.id;
      handleSubmit(values);
    }
  });

  return (
    <>
      <Modal
        open={open}
        onClose={handleCloseModal}
      >
        <Card sx={{ ...style, width: '35vw' }}>
          <CardHeader
            title={`Zamówienie ${order.identifier}`}
            sx={{ textAlign: 'center' }}
            action={
              <IconButton color="primary" onClick={handleCloseModal}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <Stack direction="row" justifyContent="left" spacing={4}>
              <Typography variant="body2">opiekun: <span style={{ fontWeight: 'bold' }}>{order.guardian_name}</span></Typography>
              <Typography variant="body2">uczestnik: <span style={{ fontWeight: 'bold' }}>{order.participant_name}</span></Typography>
              <Typography variant="body2">status: <span style={{ fontWeight: 'bold', color: order.state_color }}>{order.state_name}</span></Typography>
            </Stack>
            <Box height={10}/>
            <Divider />
            <Box height={10}/>
            <Stack direction="row" justifyContent="left" spacing={4}>
              <Typography variant="body2">e-mail: <span style={{ fontWeight: 'bold' }}>{order.guardian_correspondence_email}</span></Typography>
              <Typography variant="body2">numer telefonu: <span style={{ fontWeight: 'bold' }}>{order.guardian_phone}</span></Typography>
            </Stack>
            <Box height={20}/>
            <form onSubmit={formik.handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
              <TextField
                id="subject"
                name="subject"
                label="Temat"
                value={formik.values.subject}
                onChange={formik.handleChange}
                error={formik.errors.subject && formik.touched.subject}
                helperText={formik.errors.subject}
              />
              <Box height={20}/>
              <TextField
                id="message"
                name="message"
                multiline
                rows={8}
                label="Treść wiadomości"
                value={formik.values.message}
                onChange={formik.handleChange}
                error={formik.errors.message && formik.touched.message}
                helperText={formik.errors.message}
              />
              { error
                ? <>
                  <Box height={40}/>
                  <Alert variant="outlined" severity="error">Nie udało się wysłać wiadomości</Alert>
                </>
                : null}
              <Box height={40}/>
              { loading
                ? <>
                  <LinearProgress color="primary" />
                </>
                : !order.manual_notifications
                  ? <Alert variant="outlined" severity="warning">Powiadomienia ręczne dla tego zamówienia są wyłączone</Alert>
                  : <Button type="submit" variant="contained">
                  Wyślij wiadomość
                  </Button>}
            </form>
          </CardContent>
        </Card>
      </Modal>
      <SnackbarAlert open={openSnackbar} severity="success" message="Wiadomość została wysłana" onClose={handleCloseSnackbar} />
    </>
  );
}

